import { CalendarClock, ClipboardCheck, PhoneCall, UserRoundPlus } from "lucide-react";
import { CallNowPanel } from "./CallNowPanel";

const TaskIcon = ({ kind }) => {
  const Icon = kind === "meeting_outcome" || kind === "call_outcome" ? ClipboardCheck
    : kind === "assignment" ? UserRoundPlus : kind.startsWith("book") || kind === "reschedule" ? CalendarClock : PhoneCall;
  return <Icon size={19} aria-hidden="true" />;
};
const clock = (stamp) => new Intl.DateTimeFormat("it-IT", {
  timeZone: "Europe/Rome", weekday: "short", day: "numeric", month: "short",
  hour: "2-digit", minute: "2-digit",
}).format(new Date(stamp));

export const TodayTaskList = ({ tasks = [], call, onOpen, onCall, onVisit, onSkip }) => <section
  className="today-tasks" data-testid="today-tasks">
  <h2 className="section-label">DA FARE</h2>
  {!tasks.length && <p className="today-tasks-empty" data-testid="today-tasks-empty">Tutto in ordine. Nessuna azione in sospeso.</p>}
  {tasks.map((task) => <div className={`today-task${task.due ? " is-due" : ""}`} key={task.venue_id}
    data-testid={`today-task-${task.venue_id}`}>
    <button type="button" className="today-task-main" onClick={() => onOpen(task)}
      data-testid={`today-task-open-${task.venue_id}`}>
      <span className="today-task-icon"><TaskIcon kind={task.kind} /></span>
      <span className="today-task-copy"><strong data-testid={`today-task-name-${task.venue_id}`}>{task.venue_name}</strong>
        <span data-testid={`today-task-label-${task.venue_id}`}>{task.label}</span>
        <small data-testid={`today-task-due-${task.venue_id}`}>{task.due ? "Da fare · " : "Programmato · "}{clock(task.due_at)}</small></span><span aria-hidden="true">›</span>
    </button>
    {["first_call", "callback"].includes(task.kind) && call?.id === task.venue_id && <CallNowPanel
      venue={call} onOutcome={() => onOpen(task)} onCall={onCall} onVisit={onVisit} onSkip={onSkip} />}
  </div>)}
</section>;